import { render, staticRenderFns } from "./TableWaiters.vue?vue&type=template&id=8367de10&class=background-template&"
import script from "./TableWaiters.vue?vue&type=script&lang=js&"
export * from "./TableWaiters.vue?vue&type=script&lang=js&"
import style0 from "./TableWaiters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports